/**
 * Created by wuhuping on 2017/6/5.
 */
import * as types from '../mutation-types'
import router from '../../router'
import $ from 'jquery'

// initial state
const state = {
  showTabbar: false,
  jPushID: window.localStorage.jPushID,
  isFirstPop: true // 是否第一次显示营销弹窗
}
// getters
const getters = {}

// actions
const actions = {
  quitToLogin: function (context, flag) {
    router.push({name: 'Login'})
  },
  switchTabbarShow: function (context, show) {
    context.commit(types.SHOW_TABBAR, show)
  },
  saveJPushID: function (context, data) {
    context.commit(types.JPUSHID, data)
  }
}

// mutations
const mutations = {
  [types.SHOW_TABBAR](state, show) {
    state.showTabbar = show
  },
  [types.JPUSHID](state, data) {
    window.localStorage.setItem('jPushID', data)
    state.jPushID = data;
  },
  changeShowFirstPop(state, value) {
    state.isFirstPop = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js